// extracted by mini-css-extract-plugin
module.exports = {"auBanner":"auBanner_auBanner__0FMIJ"};